import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_sidebar = _resolveComponent("md-sidebar")!

  return (_openBlock(), _createBlock(_component_md_sidebar, { menu: _ctx.menu }, null, 8, ["menu"]))
}